import { FeatureService } from './../../../../../../../core/services/feature/feature.service';
import { Component, OnInit, ViewChild, Input, EventEmitter, Output } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from '@angular/material/sort';
import { MasterClienteHomeCreateProfileService } from "../../service/master-cliente-home-create-profile.service";
@Component({
  selector: "app-table-cliente-create-profile",
  templateUrl: "./table-cliente-create-profile.component.html",
  styleUrls: ['./table-cliente-create-profile.component.scss']

})
export class AppTableClienteCreateProfile implements OnInit {

  constructor(private masterCreateProfileService: MasterClienteHomeCreateProfileService,
    private featureService:FeatureService) {

  }
  dataTableInfo: any;
  allChecked: boolean = false
  dataTableFilter: any;
  filterAutoComplete: any
  maxItems = 8;

  @ViewChild('sort', { static: false }) sort: MatSort;
  @Input() dataTable: Array<any>
  @Input() dataRetrieveNode: string;
  @Input() idCheckboxHeader: number;
  @Output() rolesSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() relatoriosSelectionChanged = new EventEmitter<boolean>();
  @Output() allRelatoriosToggled = new EventEmitter<boolean>();


  ngOnInit() {
    this.getDataTable()
    this.dataTableInfo.sort = this.sort;
  }

  ngAfterViewInit() {
    this.dataTableInfo.sort = this.sort;
  }

  someComplete() {
    return this.dataTableInfo.data.some(ele => ele.checked == true);
  }


  getDataTable() {
    const dataCheckAdd = this.dataTable.map((data) => {
      if (!data.checked) {
        return data.checked = false;
      }
    })
    let dataTable = this.dataTable;
    dataTable.forEach(element=>{
      element.name = this.featureService.translatorService.translateEnumItem(element.name,'PermissionsType')

    })
    dataTable.sort((a, b) => {
      if (a.name === null) { a.name = '' };
      if (b.name === null) { b.name = '' };
      return (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
    })
    this.dataTableInfo = new MatTableDataSource(dataTable);

    this.dataTableInfo.sort = this.sort;
    this.isAllSelected()

  }

  filterDataTableInput(event) {
    this.dataTableInfo.filterPredicate = (data, filter) => {
      data.name = this.featureService.translatorService.translateEnumItem(data.name,'PermissionsType')
      return data.name.toLowerCase().includes(filter.toLowerCase()) || data.name.toLocaleLowerCase().includes(filter.toLocaleLowerCase());
    }
    this.dataTableFilter = (event.target as HTMLInputElement).value;
    this.dataTableInfo.filter = this.dataTableFilter
    if (this.dataTableFilter.length == 1 || (this.dataTableFilter.length > 0 && this.dataTableFilter.length % 2 == 0)) {
      this.filterAutoComplete = this.dataTableInfo.filteredData;
    } else if (this.dataTableFilter.length == 0) {
      this.dataTableInfo.filter = this.dataTableFilter
      this.filterAutoComplete = []
    }

  }

  toogleAllSelected() {
    this.allChecked = !this.allChecked;
    this.dataTableInfo.data.forEach((row) =>{
      row.checked = this.allChecked
      // If this is the Relatorios permission, emit the event
      if (row.name === 'Relatórios'  ||row.name ==='Reports') {
        this.allRelatoriosToggled.emit(this.allChecked);
      }

    } ) 
    this.onSelectRole()
  }

  isAllSelected() {
    this.allChecked = this.dataTableInfo.data.every((row) => row.checked == true);
    this.onSelectRole()
  }

  toggleSelection(row) {
    this.dataTableInfo.data.forEach((data) => {
      if (row.id === data.id) {
        row.checked = !row.checked;
      }
    })
    this.isAllSelected();
    this.onSelectRole();
    if (row.name === 'Relatórios'  ||row.name ==='Reports') {
      this.relatoriosSelectionChanged.emit(row.checked);
    }
  }
  isSelected(row) {
    const isSelected = JSON.parse(row.checked);
    return isSelected;
  }
  onSelectRole() {
    this.masterCreateProfileService.setRoles(this.dataTableInfo.data, this.dataRetrieveNode)
    this.rolesSelected.emit(this.dataTableInfo.data)
  }
}